// Libs
import { createSelector } from 'reselect'
import _escapeRegExp from 'lodash/escapeRegExp'
import _find from 'lodash/find'

// Selectors
import layersOfSelectedJob$ from './layersOfSelectedJob'
import selectedSoilTestFilter$ from 'hfty-map/src/selectors/selectedSoilTestFilter'

// Constants
import { SOIL_TEST_TO_LAYER_MAP } from 'fc-model-soil-test-results/src/constants'

export default createSelector(
  [
    layersOfSelectedJob$,
    selectedSoilTestFilter$,
  ],
  (layers, filter) => {
    const mappedAttribute = _escapeRegExp(SOIL_TEST_TO_LAYER_MAP[filter])

    if (mappedAttribute) {
      const selectedLayer = _find(layers, (layer) => {
        const target = new RegExp(`- ${mappedAttribute}_`)

        return target.test(layer.label)
      })

      return selectedLayer
    }

    return null
  }
)
